import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectAuth } from "../../../redux/features/auth/auth-slice";
import { EApplicationType } from "../../../shared/oversight-core/enums/application-type";
import { EInverterPhaseType } from "../../../shared/oversight-core/enums/inverter-phase-type";
import { ESolarSolutionType } from "../../../shared/oversight-core/enums/sola-solution-type";
import { ESolarSystemType } from "../../../shared/oversight-core/enums/solar-system-type ";
import { EUtilityOptionType } from "../../../shared/oversight-core/enums/utility-option-type";
import { IAdvancedSave } from "../../../shared/oversight-core/interfaces/advanced-save";
import { AppRoute } from "../../../shared/oversight-core/interfaces/app-routes";
import ModalContainer, {
  ModelContainerProps,
} from "../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import styles from "./calculate-energy-modal.module.scss";

interface IProps extends ModelContainerProps {
  show: boolean;
  numberOfUsers: number;
  applicationType: EApplicationType;
  utilityOption: EUtilityOptionType;
  solarSolutionType: ESolarSolutionType;
  systemType: ESolarSystemType;
  inverterPhaseType: EInverterPhaseType;
  estimationId: string;
  estimationToken: string;
  isDarkMode: boolean;
}

const CalculateEnergyModal = (props: IProps) => {
  const {
    show,
    numberOfUsers,
    applicationType,
    utilityOption,
    solarSolutionType,
    systemType,
    inverterPhaseType,
    estimationId,
    estimationToken,
    isDarkMode = false,
    ...rest
  } = props;
  const auth = useSelector(selectAuth);

  const navigate = useNavigate();

  return (
    <ModalContainer
      title="Calculate Your Energy Need"
      {...rest}
      show={show}
      size="modal-lg"
      isButtonsVisible={false}
    >
      <>
        <Row className="mx-0 gap-4">
          <Col
            className={`text-center bg-primary py-5 px-4 rounded-3 cursor-pointer ${styles.cardContainerOne}`}
            onClick={() => {
              if (!auth.token) {
                navigate(AppRoute.PUBLIC_DESIGN_SYSTEM_SIMPLIFIED_USAGE_INFO, {
                  state: {
                    numberOfUsers,
                    applicationType,
                    utilityOption,
                    solarSolutionType,
                    systemType,
                    inverterPhaseType,
                    estimationId,
                    estimationToken,
                  },
                });
                return;
              }
              navigate(AppRoute.DESIGN_SYSTEM_SIMPLIFIED_USAGE_INFO, {
                state: {
                  numberOfUsers,
                  applicationType,
                  utilityOption,
                  solarSolutionType,
                  systemType,
                  inverterPhaseType,
                  estimationId,
                  estimationToken,
                },
              });
            }}
          >
            <Row>
              <Col className="text-white font-weight-600 font-size-16">
                Simplified
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="text-gray-10 font-weight-400 font-size-14">
                Simplified method takes less time and limited amount of data to
                calculate the energy need. (Less Accurate)
              </Col>
            </Row>
          </Col>
          <Col
            className={`text-center py-5 px-4 rounded-3 cursor-pointer ${styles.cardContainerTwo}`}
            onClick={() => {
              const advancedSave: IAdvancedSave = {
                estimationType: solarSolutionType,
                applicationType,
                utilityOption,
                systemType,
                numberOfUsers,
                inverterPhaseType,
                estimationId,
              };

              if (!auth.token) {
                localStorage.setItem(
                  "redirect",
                  AppRoute.DESIGN_SYSTEM_ADVANCED_DEVICES
                );
                localStorage.setItem(
                  "advancedSave",
                  JSON.stringify(advancedSave)
                );
                navigate(AppRoute.LOGIN);
                return;
              }
              navigate(AppRoute.DESIGN_SYSTEM_ADVANCED_DEVICES, {
                state: {
                  systemType,
                  numberOfUsers,
                  applicationType,
                  utilityOption,
                  solarSolutionType,
                  inverterPhaseType,
                  estimationId,
                  estimationToken,
                },
              });
            }}
          >
            <Row>
              <Col
                className={`${
                  isDarkMode ? `text-white` : `text-primary`
                } font-weight-600 font-size-16`}
              >
                Advanced
              </Col>
            </Row>
            <Row className="mt-3">
              <Col className="text-advance-description font-weight-400 font-size-14">
                Advanced method takes more time and high amount of data to
                calculate the energy need. (More Accurate)
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    </ModalContainer>
  );
};

export default CalculateEnergyModal;
